'use strict';

const typoTokens = (theme) => ({
    typoTextColor: theme.colors.body.text,
    typoBackgroundColor: theme.colors.body.background,
    typoLetterSpacing: theme.typography.letterSpacing.m,
    typoFontFamily: theme.typography.fontFamily.regular,
    typoHeading1FontWeight: theme.typography.fontWeight.bold,
    typoHeading1FontSize: theme.typography.fontSize.xxxl,
    typoHeading1LineHeight: theme.typography.lineHeight.xxxl,
    typoHeading2FontWeight: theme.typography.fontWeight.bold,
    typoHeading2FontSize: theme.typography.fontSize.xxl,
    typoHeading2LineHeight: theme.typography.lineHeight.xxl,
    typoHeading3FontWeight: theme.typography.fontWeight.bold,
    typoHeading3FontSize: theme.typography.fontSize.xl,
    typoHeading3LineHeight: theme.typography.lineHeight.xl,
    typoHeading4FontWeight: theme.typography.fontWeight.bold,
    typoHeading4FontSize: theme.typography.fontSize.l,
    typoHeading4LineHeight: theme.typography.lineHeight.l,
    typoHeading5FontWeight: theme.typography.fontWeight.bold,
    typoHeading5FontSize: theme.typography.fontSize.m,
    typoHeading5LineHeight: theme.typography.lineHeight.s,
    typoSubtitleFontWeight: theme.typography.fontWeight.semibold,
    typoSubtitleFontSize: theme.typography.fontSize.m,
    typoSubtitleLineHeight: theme.typography.lineHeight.m,
    typoSubtitleLightFontWeight: theme.typography.fontWeight.normal,
    typoSubtitleLightFontSize: theme.typography.fontSize.m,
    typoSubtitleLightLineHeight: theme.typography.lineHeight.m,
    bodyFontWeight: theme.typography.fontWeight.bold,
    bodyFontSize: theme.typography.fontSize.s,
    bodyLineHeight: theme.typography.lineHeight.s,
    bodyLightFontWeight: theme.typography.fontWeight.semibold,
    bodyLightFontSize: theme.typography.fontSize.s,
    bodyLightLineHeight: theme.typography.lineHeight.s,
    bodyLighterFontWeight: theme.typography.fontWeight.normal,
    bodyLighterFontSize: theme.typography.fontSize.s,
    bodyLighterLineHeight: theme.typography.lineHeight.s,
    captionFontWeight: theme.typography.fontWeight.semibold,
    captionFontSize: theme.typography.fontSize.xs,
    captionLineHeight: theme.typography.lineHeight.xs,
});

exports.typoTokens = typoTokens;
//# sourceMappingURL=typo.js.map
